import { defineMessages } from 'react-intl';

export default defineMessages({
    Actions: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Actions',
        defaultMessage: 'Actions'
    },
    ActionsMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Actions Mobile',
        defaultMessage: 'Actions'
    },
    AddWatercraft: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Add Watercraft',
        defaultMessage: 'Add Watercraft'
    },
    AddWatercraftPopupHeader: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Add a Watercraft',
        defaultMessage: 'Add a Watercraft'
    },
    EditWatercraftPopupHeader: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Edit a Watercraft',
        defaultMessage: 'Edit a Watercraft'
    },
    DateOfBirth: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Date of Birth',
        defaultMessage: 'Date of Birth'
    },
    DateOfBirthMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Date of Birth Mobile',
        defaultMessage: 'Date of Birth'
    },
    GPAButtonLabel: {
        id: 'common.views.ml-pup-add-edit-watercraft-operator-dialog.Add Watercraft',
        defaultMessage: 'Add Watercraft '
    },
    WatercraftHeader: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.Watercraft',
        defaultMessage: 'Watercraft'
    },
    TYPE: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.TYPE',
        defaultMessage: 'TYPE'
    },
    TYPEMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.TYPE Mobile',
        defaultMessage: 'TYPE:'
    },
    YEAR: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.YEAR',
        defaultMessage: 'YEAR'
    },
    YEARMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.YEAR Mobile',
        defaultMessage: 'YEAR:'
    },
    MAKE: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.MAKE',
        defaultMessage: 'MAKE'
    },
    MAKEMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.MAKE Mobile',
        defaultMessage: 'MAKE:'
    },
    MODEL: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.MODEL',
        defaultMessage: 'MODEL'
    },
    MODELMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.MODEL Mobile',
        defaultMessage: 'MODEL:'
    },
    EXCLUDED: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.EXCLUDED',
        defaultMessage: 'EXCLUDED'
    },
    EXCLUDEDMobile: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.EXCLUDED Mobile',
        defaultMessage: 'EXCLUDED:'
    },
    yes: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.yes',
        defaultMessage: 'Yes'
    },
    no: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.no',
        defaultMessage: 'No'
    },
    itemHasBeenAdded: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.item has been added',
        defaultMessage: '<strong>{item}</strong> has been added.'
    },
    itemHasBeenRemoved: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.item has been removed',
        defaultMessage: '<strong>{item}</strong> has been removed. <a>Undo</a>'
    },
    WatercraftParagraph: {
        id: 'quoteandbind.pup.views.pup-watercraft-exposures.no information exists',
        defaultMessage: 'No Information Exists'
    },
});
